/* eslint-disable */
import listing from "@/apollo/packages/media/listing.gql";

export const state = () => ({
  listing: [],
  is_loading: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 26 Apr 2024 | 10:40AM
   * @param {*} state
   * @param {*} value
   */
  setListing(state, value) {
    state.listing = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 26 Apr 2024 | 10:40AM
   * @param {*} state
   * @param {*} value
   */
  setLoading(state, value) {
    state.is_loading = value;
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 26 Apr 2024 | 10:41AM
   * @param {*} { commit }
   * @param {*} dest_id
   * @returns {*}
   */
  fetchListing({ commit }, dest_id) {
    commit("setListing", []);
    commit("setLoading", true);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing, variables: { dest_id } })
        .then(({ data }) => {
          commit("setListing", data.pkgDestinationMedia);
          resolve(data.pkgDestinationMedia);
          commit("setLoading", false);
        })
        .catch(() => {
          commit("setLoading", false);
        });
    });
  }
};

export const getters = {
  listing: (state) => state.listing,
  is_loading: (state) => state.is_loading
};
